import { useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { makeCoreGetRequest } from '../../../utils/api'
import { formatErrorMessage } from '../../../utils/formatting'
import { useNotification } from '../../../hooks'
import { getUserRoles, logout } from '../../../utils/authService'
import { useAuth } from 'oidc-react'
import { useOfflineTool } from '../../core-ui/Offline'

export const useTitle = () => {
  const { showNotification } = useNotification()
  const userRoles = getUserRoles()
  const auth = useAuth()
  const offlineTool = useOfflineTool()

  const [modalVisible, setModalVisible] = useState(false)
  const [modalMessage, setModalMessage] = useState('')

  const errorHandler = error => {
    showNotification({
      message: `${formatErrorMessage(error)}`,
      type: 'error'
    })
  }

  const fetchShopName = async () => {
    return await makeCoreGetRequest('/shop-reception-mobile/home/shop-name')
  }

  const fetchHubName = async () => {
    return await makeCoreGetRequest('/shop-reception-mobile/home/hub-name')
  }

  const fetchDepositName = async () => {
    return await makeCoreGetRequest('/shop-reception-mobile/home/deposit-name')
  }

  const { data: shopName } = useQuery('shop-name', fetchShopName, {
    enabled: ['GG_RO_HQ_SHOP_RECEPTION_STORE', 'GG_RO_HQ_SHOP_RECEPTION_BACKOFFICE'].some(role =>
      userRoles?.includes(role)
    ),
    onError: error => errorHandler(error),
    onSuccess: data => {
      if (data?.value === 'Magazin Neidentificat') {
        setModalMessage(
          'Nu aveți un magazin asociat contului. Vă rugăm adaugați un tichet în Service Now pentru asocierea la magazin!'
        )
        setModalVisible(true)
      }
    }
  })

  const { data: hubName } = useQuery('hub-name', fetchHubName, {
    enabled: userRoles?.includes('GG_RO_HQ_SHOP_RECEPTION_HUB'),
    onError: error => errorHandler(error),
    onSuccess: data => {
      if (data?.value === 'HUB Neidentificat') {
        setModalMessage(
          'Nu aveți un hub asociat contului. Vă rugam să contactați responsabilul Carrefour pentru asocierea la hub!'
        )
        setModalVisible(true)
      }
    }
  })

  const { data: depositName } = useQuery('deposit-name', fetchDepositName, {
    enabled: userRoles?.includes('GG_RO_HQ_SHOP_RECEPTION_WAREHOUSE'),
    onError: error => errorHandler(error),
    onSuccess: data => {
      if (data?.value === 'DEPOZIT Neidentificat') {
        setModalMessage(
          'Nu aveți un depozit asociat contului. Vă rugam să contactați responsabilul Carrefour pentru asocierea la depozit!'
        )
        setModalVisible(true)
      }
    }
  })

  const title = useMemo(
    () => shopName?.value || hubName?.value || depositName?.value || '',
    [shopName, hubName, depositName]
  )

  const handleModalOk = () => {
    setModalVisible(false)
    logout()
    offlineTool.deleteOwnTasks()
    auth.signOutRedirect()
  }

  return {
    title,
    modalVisible,
    modalMessage,
    handleModalOk
  }
}
